import Planos from "@/Pages/Planos/index.vue";
import PlanosBimestrais from "@/Pages/PlanosBimestrais/index.vue";
import PlanosInfantil from "@/Pages/PlanosInfantil/index.vue";
import PlanosVisualizar from "@/Pages/Planos/visualizar.vue";
import PlanosVisualizarBimestrais from "@/Pages/PlanosBimestrais/visualizar.vue";
import PlanosInfantilVisualizar from "@/Pages/PlanosInfantil/visualizar.vue";
import PlanosInfantilBimestrais from "@/Pages/PlanosInfantilBimestrais/index.vue";
import PlanosInfantilVisualizarBimestrais from "@/Pages/PlanosInfantilBimestrais/visualizar.vue";

export default [
  {
    path: "/gestoes-de-aulas/planos",
    name: "gestoesDeAulas.planos",
    component: Planos,
  },
  {
    path: "/gestoes-de-aulas/planos/:id/visualizar",
    name: "gestoesDeAulas.planosVisualizar",
    component: PlanosVisualizar,
  },
  {
    path: "/gestoes-de-aulas/planos-bimestrais",
    name: "gestoesDeAulas.planosBimestrais",
    component: PlanosBimestrais,
  },
  {
    path: "/gestoes-de-aulas/planos-bimestrais/:id/visualizar",
    name: "gestoesDeAulas.planosVisualizarBimestrais",
    component: PlanosVisualizarBimestrais,
  },
  // Infantil
  {
    path: "/gestoes-de-aulas/planos/infantil",
    name: "gestoesDeAulas.planosInfantil",
    component: PlanosInfantil,
  },
  {
    path: "/gestoes-de-aulas/planos/infantil/:id/visualizar",
    name: "gestoesDeAulas.planosInfantilVisualizar",
    component: PlanosInfantilVisualizar,
  },
  {
    path: "/gestoes-de-aulas/planos-bimestrais/infantil",
    name: "gestoesDeAulas.planosInfantilBimestrais",
    component: PlanosInfantilBimestrais,
  },
  {
    path: "/gestoes-de-aulas/planos-bimestrais/infantil/:id/visualizar",
    name: "gestoesDeAulas.planosInfantilVisualizarBimestrais",
    component: PlanosInfantilVisualizarBimestrais,
  },
];
